exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "figure {\r\n    overflow: hidden;\r\n}\r\n\r\ndiv.container {\r\n    display: inline;\r\n    text-align: center;\r\n}\r\n\r\ndiv.image-wrapper {\r\n    border-radius: 100%;\r\n    width: 230px;\r\n    height: 230px;\r\n    overflow: hidden;\r\n    -webkit-mask-image: -webkit-radial-gradient(circle, white, black);\r\n}\r\n\r\nimg {\r\n    border-radius: 100%;\r\n    width: 230px;\r\n    height: 230px;\r\n    overflow: hidden;\r\n    -webkit-transition: 200ms ease-out;\r\n    transition: 200ms ease-out;\r\n}\r\n\r\nimg:hover {\r\n    -webkit-transform: scale(1.1);\r\n    transform: scale(1.1);\r\n    -webkit-transition: 200ms ease-in;\r\n    transition: 200ms ease-in;\r\n}\r\n\r\n.title {\r\n    font-family: Corbel;\r\n    font-size: 24px;\r\n    line-height: 24px;\r\n    color: #2b2b2b;\r\n    padding-top: 38px;\r\n    width: 210px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.description {\r\n    font-family: Corbel;\r\n    font-size: 14px;\r\n    line-height: 14px;\r\n    color: #7a7a7a;\r\n    padding-top: 7px;\r\n    width: 210px;\r\n    margin: 0 auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/intro-section/round-info/round-info.component.css
// module id = 758
// module chunks = 1